import { action, observable } from "mobx";
import { getNotifications } from '@/services/home';
import HomeStore from './HomeStore';

class ModalStore {
  
  // 所以弹窗状态
  @observable modalVisible
  
  
  @action.bound modalShow (name: string) {
    this.setModalState(name, true)
  }
  
 
  @action.bound modalHide (name: string) {
    console.log(name);
    this.setModalState(name, false)
    const index = this.modalVisible.map(r => r.name).indexOf(name);
    if (this.modalVisible.length - 1 !== index) {
      this.modalVisible[index + 1].visible = true
    }
  }
  
  @action.bound setModalState (name: string,visible: boolean) {
    this.modalVisible = this.modalVisible.map(r => {
      if (r.name === name) {
        r.visible = visible
      }
      return r
    })
  }
  
  // 获取消息弹窗
  @action.bound async getNotifications () {
    
    const response = await getNotifications({msg_type: 1})
    if (response.code === 10000) {
      if (response.result.open_message_list.length === 0) return;
      this.modalVisible = response.result.open_message_list.map(r => ({
        bodyType:  r.bodyType,
        imageUrl: r.imageUrl,
        title: r.title,
        id: r.id,
        name: r.number,
        visible: false,
        description: r.number,
        onClose: () => this.modalHide(r.number)
      }))
      
      let  modalList: any [] = window.localStorage.getItem('modalList') ?
        JSON.parse(window.localStorage.getItem('modalList') || '') : []
      let account = window.localStorage.getItem('account') || ''
      let modalIds = modalList .map(r => r.id)
      let accounts = modalList.map(r => r.account)
      if (modalIds.indexOf(this.modalVisible[0].id) === -1 || accounts.indexOf(account) === -1) {
        modalList.push( {id: this.modalVisible[0].id, time: new Date().getTime(), account})
        window.localStorage.setItem('modalList', JSON.stringify(modalList))
        this.modalShow(this.modalVisible[0].name)
        return false
      }
      if (modalIds.indexOf(this.modalVisible[0].id) !== -1) {
        if (modalList[modalIds.indexOf(this.modalVisible[0].id)].account !== account && accounts.indexOf(account) === -1) {
          modalList.push( {id: this.modalVisible[0].id, time: new Date().getTime(), account})
          window.localStorage.setItem('modalList', JSON.stringify(modalList))
          this.modalShow(this.modalVisible[0].name)
          return false
        }
      }
      
      if (accounts.indexOf(account) !== -1) {
        let newTime = new Date().getTime()
        if (newTime - modalList[accounts.indexOf(account)].time > 3600000  ) {
          modalList[accounts.indexOf(account)].time = newTime
          window.localStorage.setItem('modalList', JSON.stringify(modalList))
          this.modalShow(this.modalVisible[0].name)
          return false
        }
      }
      
      
    }
    
  }
  
  
}

export default new ModalStore();
